// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4336ba84","453":"45547c62","732":"1f3d6650","977":"a2321aaa"}[chunkId] + ".chunk.js";
};